import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import type { AppDispatch, RootState } from './store'

export const useAnalysisDispatch: () => AppDispatch = useDispatch
export const useAnalysisSelector: TypedUseSelectorHook<RootState> = useSelector

